import { Outlet } from 'react-router-dom';

import { AdminSidebar } from './components/AdminSidebar';
import { AdminHeader } from './components/AdminHeader';
import Section from '../../components/Modular/Section';
import Layout from '../../components/Modular/Layout';
import Unit from '../../components/Modular/Unit';

export function AdminLayout() {
  const context = {};

  return (
    <Layout
      context={context}
      layout="grid"
      gridTemplate="dashboard"
      background="brand-secondary"
    >
      <Section paddingLeft="lg" paddingTop="md" gridArea="area-1">
        <AdminSidebar></AdminSidebar>
      </Section>
      <Section gridArea="area-2">
        <AdminHeader></AdminHeader>
        <Section
          background="surface"
          marginTop="lg"
          height="10"
          borderRadius="sm"
        >
          <Outlet></Outlet>
        </Section>
      </Section>
    </Layout>
  );
}
